import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { AboutServices } from './components/AboutServices';
import { Team } from './components/Team';
import { Projects } from './components/Projects';
import { Construction } from './components/Construction';
import { ProcessTestimonials } from './components/ProcessTestimonials';
import { EditorialContact } from './components/EditorialContact';
import { FloatingUi } from './components/FloatingUi';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-[#F7F4EF] text-[#1A1A1A]" data-id="element-0" data-mp="2mn5ash5h0lgp">
      <Navigation data-id="element-1" data-mp="31bs1tg4gn1nr" />
      <main data-id="element-2" data-mp="31c9vq63nh3si">
        <Hero data-id="element-3" data-mp="31c1ksjr388jy" />
        <AboutServices data-id="element-4" data-mp="31cjou2jzrr2f" />
        <Construction data-id="element-5" data-mp="2wjgqzi86lvgf" />
        <ProcessTestimonials data-id="element-6" data-mp="2wiyvintcfl9k" />
        <Team data-id="element-7" data-mp="2wip36tktt20p" />
        <Projects data-id="element-8" data-mp="2wi5l9cv6edmo" />
        <EditorialContact data-id="element-9" data-mp="28u5ysp4wd9dw" />
      </main>
      <FloatingUi data-id="element-10" data-mp="28t4k8aooa4rf" />
    </div>;
}